import React, { Component } from 'react';
import './step.css';
// import formValidation from './formValidation.js';
// formValidation();

function Step1 (props){

  return(
    <div>
      <form id="myForm" className="step-container" onSubmit={props.submitUser.bind(this)}>
      <div className="input-container">
        <p className="step-input">First name: <input name="user[firstName]" className="inputField" required onChange={props.updateFirstName} placeholder="First Name"/></p>

        <p className="step-input">Last Name: <input name="user[lastName]" className="inputField" required onChange={props.updateLastName} placeholder="Last Name"/></p>

        <p className="step-input">  Email: <input className="inputField" name="user[email]"required type="email" onChange={props.updateEmail} placeholder="Email"/></p>

        <p className="step-input">Business Name: <input className="inputField" name="business[businessName]" required onChange={props.updateBusinessName} placeholder="Business Name"/></p>

        <p className="step-input">Business Phone Number: <input className="inputField" required type="tel" name="business[phone]" onChange={props.updatePhone} placeholder="Business Phone Number"/></p>

        <p className="step-input">Business Website: <input name="business[website]" className="inputField"  type="url" onChange={props.updateWebsite} placeholder="Business Website"/></p>

        <p className="step-input">Username: <input className="inputField" placeholder="User Name" id="field_username" name="user[userName]" onChange={props.updateUserName} title="Username must not be blank and contain only letters, numbers and underscores." type="text" required pattern="\w+" name="username" /></p>

        <p className="step-input">Password: <input className="inputField" name="user[password]" id="field_pwd1" placeholder="Password" title="Password must contain at least 6 characters, including UPPER/lowercase and numbers." onChange={props.updatePassword} type="password" required pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}" name="pwd1" /></p>

        <p className="step-input">Confirm Password: <input className="inputField" id="field_pwd2" placeholder="Confirm Password" onChange={props.confirmPassword} title="Please enter the same Password as above." type="password" required pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}" name="pwd2" /></p>
        </div>


        <div id="createUser"><button className="step-button" type="submit" id="step1Button" value="submit">Next Step</button></div>
      </form>
      <h2 className="stepNumber">Step 1 of 3</h2>
      </div>
)

}






export default Step1;



// WEBPACK FOOTER //
// ./src/step1.js